import React, { useEffect } from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Slider from "react-slick";
import CircularProgress from "@mui/material/CircularProgress";
import { Link } from "react-router-dom";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../hooks/usedTypedSelector";
import { getAreas } from "../../../features/middleware/areaMiddleware";

const AreaServe = () => {
  // prev & next button custom for react slick plugin

  const PreviousBtn = (props: any) => {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <svg width="32" height="25" viewBox="0 0 32 25">
          <path
            fill="#3D3D3D"
            fillRule="evenodd"
            d="M0 12a1.22 1.22 0 0 1 0-.13v-.11a1.25 1.25 0 0 1 0-.13l.05-.1.07-.12.07-.09.08-.1L11 .39a1.3 1.3 0 0 1 1.82 0 1.25 1.25 0 0 1 0 1.79l-8.43 8.56h26.32a1.3 1.3 0 0 1 0 2.59H4.29l8.55 8.55a1.25 1.25 0 0 1 0 1.79 1.3 1.3 0 0 1-1.82 0L.37 13l-.08-.09-.08-.09-.06-.11-.06-.11a1.18 1.18 0 0 1 0-.12 1.22 1.22 0 0 1 0-.12 1.16 1.16 0 0 1 0-.12 1.2 1.2 0 0 1 0-.13L0 12z"
          ></path>
        </svg>
      </div>
    );
  };
  const NextBtn = (props: any) => {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <svg width="32" height="25" viewBox="0 0 32 25">
          <path
            fill="#3D3D3D"
            fillRule="evenodd"
            d="M32 12a1.22 1.22 0 0 0 0-.13v-.11a1.25 1.25 0 0 0 0-.13l-.05-.1-.07-.12-.07-.09-.08-.1L21 .39a1.3 1.3 0 0 0-1.82 0 1.25 1.25 0 0 0 0 1.79l8.43 8.56H1.29a1.3 1.3 0 0 0 0 2.59h26.42l-8.55 8.55a1.25 1.25 0 0 0 0 1.79 1.3 1.3 0 0 0 1.82 0L31.63 13l.08-.09.08-.09.06-.11.06-.11a1.18 1.18 0 0 0 0-.12 1.22 1.22 0 0 0 0-.12 1.16 1.16 0 0 0 0-.12 1.2 1.2 0 0 0 0-.13L32 12z"
          ></path>
        </svg>
      </div>
    );
  };
  //slider setting props
  const settings = {
    dots: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <NextBtn />,
    prevArrow: <PreviousBtn />,
    responsive: [
      {
        breakpoint: 1270,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // redux dispatch func to fetch data from middleware asyncthunk
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getAreas());
  }, [dispatch]);
  const { loading, dataArea } = useAppSelector((state) => state.areaSlice);
  console.log(dataArea);
  return (
    <section
      id="area"
      style={{
        position: "relative",
      }}
    >
      <Container
        maxWidth="lg"
        sx={{ padding: { md: "130px 0px 0px", sm: "120px 0px 0px" } }}
        className="area-container"
      >
        <Box sx={{ zIndex: 100 }}>
          <Grid container>
            <Grid item xs={12} md={12} sx={{ marginLeft: { sm: "9px" } }}>
              <Typography variant="h5" gutterBottom sx={{ pb: 5 }}>
                Area we serve
              </Typography>
            </Grid>

            {loading && (
              <Grid item xs={12} md={12}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress />
                </Box>
              </Grid>
            )}
          </Grid>
          <Box sx={{ padding: { xs: "0 13%", sm: "0 13%", md: "0 2%" } }}>
            {dataArea && (
              <Slider {...settings}>
                {dataArea?.map((data, i) => (
                  <div key={i}>
                    <Typography variant="h6" gutterBottom>
                      {data.name}
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      component="p"
                      gutterBottom
                      align="left"
                    >
                      {data.description}
                    </Typography>
                    <Link
                      to={`tel:${data.phone}`}
                      style={{
                        fontFamily: "GraphikBold",
                        fontSize: "16px",
                        lineHeight: "26px",
                        fontWeight: 500,
                        color: "rgb(61, 61, 61)",
                        transition: "all 0.3s ease 0s",
                        textDecoration: "none",
                      }}
                    >
                      Call us now
                    </Link>
                  </div>
                ))}
              </Slider>
            )}
          </Box>
        </Box>
      </Container>
    </section>
  );
};

export default AreaServe;
